module.exports = __webpack_public_path__ + "static/media/c101.e7d20de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c101.png
// module id = ./src/assets/c101.png
// module chunks = 2